import { BadgeUserStatus } from './badge-user-status';

export const userStatusToLabel: Record<BadgeUserStatus, string> = {
  incomplete: 'Incomplete',
  pending: 'Pending',
  active: 'Active',
  inactive: 'Inactive',
  deleted: 'Deleted',
  rejected: 'Rejected'
};
